var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item){return _c('HistoryCard',{key:item.id,attrs:{"item":item},nativeOn:{"click":function($event){return _vm.goToDetail(item.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }